
<div class="flex justify-center items-center h-full no-content">
  <span class="text-xs msg">{{ translatedMessage }}</span>
</div>
